import React from 'react';

const LinkedInIcon = () => (
  <svg viewBox="0 0 36 36">
    <path d="M12.5 12.5h1v1h-1zM14.839 15H12v8.852h2.839z" />
    <path d="M14.839 12H12v2h2.839zM24.824 18.808c0-2.72-1.4-3.984-3.268-3.984-1.507 0-2.182.859-2.559 1.461v-1.253h-2.84c.038.83 0 8.851 0 8.851h2.84V18.94c0-.265.018-.529.093-.718.206-.529.673-1.076 1.457-1.076 1.028 0 1.438.812 1.438 2.001v4.736h2.84v-5.075z" />
  </svg>
);

export default LinkedInIcon;
